import Title from '@wconcept/wconcept-ui-renewal/components/atoms/Title';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';

import * as S from './style';

interface IProps {
  /** title */
  title?: string;
  /** suffix */
  suffix?: React.ReactNode;
}

const ContTitleDesktop = ({ title, suffix }: IProps) => (
  <>
    <S.ContTitleDesktop className="title-cont-desktop">
      <Title level={2}>
        <Text>{title}</Text>
        {suffix && <span className="area-suffix">{suffix}</span>}
      </Title>
    </S.ContTitleDesktop>
  </>
);

export default ContTitleDesktop;
